const module = { name: 'movie/shared/desktop/spinner', exports: {} }; const exports = module.exports;



const Selectors = {
    SPINNER: '.js-spinner',
}


const Styles = {
    HIDE: 'hide'
}
function setVisibility(isVisible) {
    const spinner = document.querySelector(Selectors.SPINNER);
    if (!spinner) {
        return;
    }
    if (isVisible) {
        spinner.classList.remove(Styles.HIDE);
    }
    else {
        spinner.classList.add(Styles.HIDE);
    }
}
module.exports = {
    start() {
        setVisibility(true);
    },
    stop() {
        setVisibility(false);
    }
};
export default module.exports;